module.exports = __webpack_public_path__ + "static/img/bim2.5187734.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye/bim2.png
// module id = B01W
// module chunks = 17